import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const enterEvent: SugarElementInfo = {
    name: "enterEvent",
    availableChildren: { type: AvailableChildrenType.Any },
};
